import React, { useMemo } from 'react';

import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

import { FormControl, FormHelperText, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

import { useSuporgId } from '../../hooks';

export const SuporgPicker = (props: FieldExtensionComponentProps<string>) => {
  const {
    onChange,
    schema: { title = '', description = '' },
    required,
    rawErrors,
    formData,
    idSchema,
  } = props;

  const { suporgs } = useSuporgId();

  const labelMap = useMemo(
    () => new Map(suporgs.map(org => [org.value, org.label])),
    [suporgs],
  );

  const hasError = (rawErrors?.length ?? 0) > 0;

  return (
    <FormControl
      fullWidth
      size="small"
      required={required}
      error={hasError && !formData}
    >
      <Autocomplete
        id={idSchema?.$id}
        value={formData ?? null}
        onChange={(_: any, value: string | null) => {
          onChange(value || '');
        }}
        options={suporgs.map(org => org.value)}
        getOptionLabel={option => labelMap.get(option) || option}
        renderOption={(option: string) => labelMap.get(option) || option}
        renderInput={params => (
          <TextField
            {...params}
            label={title}
            size="small"
            required={required}
            InputProps={params.InputProps}
            variant="outlined"
            fullWidth
          />
        )}
      />
      {(hasError || description) && (
        <FormHelperText error={hasError}>
          {hasError ? rawErrors?.join(', ') : description}
        </FormHelperText>
      )}
    </FormControl>
  );
};
